module.exports = __webpack_public_path__ + "static/media/fi-rr-angle-left.5e78b980.svg";